import { useQuery } from '@tanstack/react-query'
import { getSharedProjectsCount } from '../api'

export function useSharedProjectsCount() {
    const { data, isLoading, error } = useQuery({
        queryKey: ['sharedProjectsCount'],
        queryFn: getSharedProjectsCount,
        staleTime: 5 * 60 * 1000,
    })

    return {
        count: data?.count ?? 0,
        loading: isLoading,
        error: error?.message || null,
    }
}
